import { reactive } from '@nuxtjs/composition-api';

export default () => {
  const backgroundColor = reactive({
    Gray: 'gray',
    'Gray light 1': 'gray lighten-1',
    'Gray light 2': 'gray lighten-2',
    'Gray light 3': 'gray lighten-3',
    'Gray dark 1': 'gray darken-1',
    'Gray dark 2': 'gray darken-2',
    Blue: 'primary lighten-1',
    'Blue light 1': 'primary lighten-1',
    'Blue light 2': 'primary lighten-1',
    Pink: 'secondary lighten-1',
    'Pink light 1': 'secondary lighten-1',
    'Pink light 2': 'secondary lighten-1',
    Burgundy: 'tertiary lighten-1',
    'Burgundy light 1': 'tertiary lighten-1',
    'Burgundy light 2': 'tertiary lighten-1',
    Brown: 'quaternary lighten-1',
    'Brown light 1': 'quaternary lighten-1',
    'Brown light 2': 'quaternary lighten-1',
    Lime: 'quinary lighten-1',
    'Lime light 1': 'quinary lighten-1',
    'Lime light 2': 'quinary lighten-1',
    Lightblue: 'info lighten-1',
    'Lightblue light 1': 'info lighten-1',
    'Lightblue light 2': 'info lighten-1',
    Yellow: 'warning lighten-1',
    'Yellow light 1': 'warning lighten-1',
    'Yellow light 2': 'warning lighten-1',
    Red: 'error lighten-1',
    'Red light 1': 'error lighten-1',
    'Red light 2': 'error lighten-1',
    Green: 'success lighten-1',
    'Green light 1': 'success lighten-1',
    'Green light 2': 'success lighten-1'
  })

  const themeColor = reactive({
    'Blue Background + Pink Text': 'primary',
    'Pink Background + Burgundy text': 'secondary',
    'Burgundy Background + Pink Text': 'tertiary',
    'LightBlue Background + Blue text': 'info',
    'LightGray Background + DarkGray Text': 'gray'
  })

  const getBackground = (bg) => {
    return backgroundColor[bg] || ''
  }

  const getTheme = (theme) => {
    return themeColor[theme] || ''
  }

  return {
    getBackground,
    getTheme
  }
}
